import React, {
  createContext,
  useContext,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import {useSelector} from 'react-redux'
import {selectUser} from 'features/User'
import {config, Role, Permissions} from './config'

interface PermissionsContextProps {
  role: Role | null
  permissions: Permissions
}

const PermissionsContext = createContext<PermissionsContextProps>({
  role: null,
  permissions: [],
})

export const PermissionsProvider: React.FC<{children: ReactNode}> = ({
  children,
}) => {
  const user = useSelector(selectUser)
  const [permissions, setPermissions] = useState<Permissions>([])
  const [role, setRole] = useState<Role | null>(null)

  useEffect(() => {
    if (user?.role) {
      const userRole = user.role as Role
      setRole(userRole)
      setPermissions(config[userRole].permissions)
    } else {
      setRole(null)
      setPermissions([])
    }
  }, [user])

  return (
    <PermissionsContext.Provider value={{role, permissions}}>
      {children}
    </PermissionsContext.Provider>
  )
}

export const usePermissions = () => useContext(PermissionsContext)
